/*
 FlagIcons


*/
import React from 'react';

import { IconButton, Badge } from '@material-ui/core';
import { Theme, withStyles } from "@material-ui/core/styles";
import { PropTypes } from "@material-ui/core";

import { connect } from 'react-redux';
import {
  AppState, Actions, store,
} from '../../../appredux';

import CONFIG from '../../../cfg/config';
import Flag from 'react-flagkit';

class FlagIconC extends React.Component<any, any> {

  //PM 2021-08-26
  //aktualizacja z zaktualizowana wersja react-flagkit
  render() {
    const { classes } = this.props;
    const lang = ['en', 'pl', 'sk', 'cz', 'ru', 'ua', 'de',];

    let flgs: JSX.Element[] = [];
    CONFIG.lang.forEach((c) => {
      if (lang.includes(c)) {
        let bg = '';
        let clr: PropTypes.Color;
        let cc: string;
        if (c === 'en') cc = 'GB'
        //      else if (c=='pl') cc='PL'
        else cc = c.toUpperCase()
        if (this.props.page.lang === c) { bg = 'A'; clr = 'secondary' }
        else { bg = ''; clr = 'default' }
        flgs.push(

          <IconButton key={cc} color="inherit" style={{ padding: "8px 8px 4px 8px" }} onClick={async () => { await store.dispatch(Actions.pageState.setLang(c)) }}>
            <Badge badgeContent={bg} color={clr}>
              <span>
                <Flag country={cc} size={20} />
              </span>
            </Badge>
          </IconButton>
        );
      }
    }
    );

    return (
      <div className={classes.outerPanel}>
      <div className={classes.itnl}>
        <div style={{}}>
          {flgs}
        </div>
      </div>
      </div>
    )
  }
}

const mapStateToProps = (state: AppState) => ({
  page: state.pageState
});


const styles = (theme: Theme) => ({
  outerPanel: {
    display: 'flex',
    justifyContent: 'center',
  },
  itnl: {
    // marginLeft: "2em",
    // marginRight: '2em'
    padding: '2px 2px 2px 2px',
    display: 'inline',
    justifyContent: 'center',

    height: "34px",
    border: "1px solid lavender",
  },
  flag: {
    width: "20px",
    height: "20px"
  },
});


export default connect(mapStateToProps)(withStyles(styles)(FlagIconC));